<!--
 * @Descripttion:
 * @version:
 * @Author: moBai
 * @Date: 2021-11-02 15:49:14
 * @LastEditors: mobai
 * @LastEditTime: 2022-09-21 17:08:59
-->
<template>
  <div class="container">
    <section class="heder">
      <div class="title"><span></span>标签展示</div>
      <div class="tip">
        <div>
          在此处选择想要展示到五企培育驾驶舱上的标签。最多选择8个标签。可通过拖拽，进行标签排序
        </div>
      </div>
    </section>
    <section>
      <el-form>
        <el-form-item label="选择标签">
          <!-- <el-cascader
            ref="cascader"
            v-model="value"
            :options="optionsList"
            @change="handleChange"
            :props="optionsProps"
          ></el-cascader> -->
          <el-select
            v-model="value"
            placeholder="请选择"
            filterable
            ref="select"
            popper-class="select"
            @change="handleChange"
            value-key="id"
          >
            <el-option
              v-for="item in optionsList"
              :key="item.id"
              :label="item.name"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div>
        <vue-draggable
          v-model="eightLabelList"
          animation="1000"
          @start="onStart"
          @end="onEnd"
        >
          <div
            v-for="(item, index) in eightLabelList"
            :key="index"
            class="labelList"
          >
            <div class="labelItem">
              <div>{{ item.labelName }}</div>
              <div class="delete" @click="removeLabel(item, index)">×</div>
            </div>
          </div>
        </vue-draggable>
      </div>
    </section>
  </div>
</template>

<script>
import { labelList } from '@api/cockpit/index'
import vueDraggable from 'vuedraggable'
import {
  updateEntLabelFill,
  getEntLabelFillList,
  addEntLabelFill
} from '@api/dataMaintenance/dataMaintenance'
export default {
  components: {
    vueDraggable
  },
  data() {
    return {
      optionsList: [], // 所有标签
      value: '',
      optionsProps: {
        label: 'name',
        value: 'id',
        checkStrictly: true
      },
      eightLabelList: [], // 8个标签
      labelList: [] // 修改后的数据列表
    }
  },
  watch: {},
  computed: {},
  created() {
    this.getEntLabelList()
    this.getEntLabelFillList()
  },
  mounted() {},
  methods: {
    // 获取所有标签
    getEntLabelList() {
      labelList().then((res) => {
        if (res.data.code === '0000') {
          this.optionsList = res.data.data
        }
      })
    },
    // 新增新增五企培育标签
    addEntLabelFill() {
      addEntLabelFill({
        labelName: this.labelName,
        labelId: this.labelId
      }).then((res) => {
        if (res.data.code == '0000') {
          this.getEntLabelFillList()
        }
      })
    },
    // 获取8个标签列表
    getEntLabelFillList() {
      getEntLabelFillList().then((res) => {
        if (res.data.code === '0000') {
          this.eightLabelList =
            res.data.data && res.data.data[0] ? res.data.data : []
        }
      })
    },
    // 排序和删除标签列表
    updateEntLabelFill() {
      updateEntLabelFill({ list: this.labelList }).then((res) => {
        if (res.data.code === '0000') {
          this.getEntLabelFillList()
        }
      })
    },
    handleChange(data) {
      if (this.eightLabelList.length && this.eightLabelList.length == 8) {
        this.value = ''
        return this.$message.error('最多可选择8个标签，请先删除已选择标签')
      }
      this.labelId = data.id
      this.labelName = data.name
      this.addEntLabelFill()
    },
    // 开始拖拽事件
    onStart(data) {},
    // 拖拽结束事件
    onEnd(data) {
      this.updateLabelData()
    },
    // 删除标签
    removeLabel(data, i) {
      if (this.eightLabelList && this.eightLabelList.length) {
        this.eightLabelList.splice(i, 1)
        this.updateLabelData()
      }
    },
    updateLabelData() {
      this.labelList = []
      this.eightLabelList.map((item, index) => {
        item.sort = index + 1

        this.labelList.push({
          labelName: item.labelName,
          labelId: item.labelId,
          sort: item.sort
        })
      })
      this.updateEntLabelFill()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  padding: 12px 0;
  background: #fff;
  .heder {
    margin-bottom: 15px;
    > .title {
      display: flex;
      align-items: center;
      line-height: 20px;
      > span {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #46a6ff;
        border-radius: 3px;
        margin-right: 6px;
      }
    }
    > .tip {
      margin: 20px 0;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.7);
      padding: 5px 10px;
      line-height: 24px;
      background-color: #fafafa;
    }
  }
  .labelList {
    .labelItem {
      background: rgba(242, 242, 242, 1);
      margin-top: 10px;
      padding: 10px;
      width: 30%;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
    }
  }
}
</style>
